import React from "react";
import { useSelector } from "react-redux";

import "./printDesign.less";
import { i18, trb } from "@utilities";
import moment from "moment";
import { Group, Title, Header } from "./Components";

export const PrintKYC = ({ data, componenNegativeInformation }) => {
  const {
    CISO,
    LGL_FRM,
    DOCS,
    CUREX,
    LNAM,
    INCPM,
    INCRM,
    OUTPM,
    OUTRM,
    INSTTTNL_SCTR,
    CBB,
    MCA,
    ADRT,
    ACCT,
    CMP,
    CPFSCH,
    CPFSC,
    SWC,
    CSIZE,
    CCHAN
  } = useSelector(state => state.translationReducer.translations[1].Groups);

  const yesNo = [
    { label: trb(i18.Labels.Yes), value: "1" },
    { label: trb(i18.Labels.No), value: "0" }
  ];

  const classifikatorsMap = (classObj, withSort = false, customSort = false, className = "") => {
    let obj = classObj;
    const simpleSortFunc = (a, b) => {
        return a.label > b.label ? 1 : a.label < b.label ? -1 : 0;
      },
      objectMap = obj =>
        withSort
          ? Object.entries(obj)
              .map(item => {
                return item[0] && item[1]
                  ? { label: item[1], value: item[0], className: className }
                  : item[0]
                  ? { label: item[0], value: item[0], className: className }
                  : null;
              })
              .filter(item => item)
              .sort(customSort ? customSort : simpleSortFunc)
          : Object.entries(obj)
              .map(item => {
                return item[0] && item[1]
                  ? { label: item[1], value: item[0], className: className }
                  : item[0]
                  ? { label: item[0], value: item[0], className: className }
                  : null;
              })
              .filter(item => item)
              .sort(simpleSortFunc);

    return obj ? objectMap(obj) : [];
  };

  const customSortByValueString = (a, b) => {
    const aValUC = a.value.toUpperCase();
    const bValUC = b.value.toUpperCase();

    if (aValUC === bValUC) return 0;
    return aValUC > bValUC ? 1 : -1;
  };

  const {
    clientProfile,
    clientAddress,
    clientMail,
    clientPhone,
    clientPlanServices,
    clientTaxPayerCountrys,
    companyFunds,
    clientCeo,
    clientRep,
    clientPoliticsPosition,
    clientPolitics,
    clientBeneficiaries,
    planServTurn,
    clientPlanTurn,
    PaymOut,
    mainCustom,
    clientBasicBusiness,
    clientBusPartner,
    clientPaymentForServises,
    clientFundsRecCountrys,
    clientFundsSentCountry
  } = data?.personData;

  const getClientBeneficiaries = () => {
    const benef = clientBeneficiaries.map((item, i) => {
      return {
        type: "table",
        title: i === 0 ? trb(i18.PrintLabels.ShareholderBeneficialOwner) : "",
        groupOptions: [
          { type: "colgroup", width: "8.33%" },
          { type: "colgroup", width: "8.33%" },
          { type: "colgroup", width: "8.33%" },
          { type: "colgroup", width: "8.33%" },
          { type: "colgroup", width: "8.33%" },
          { type: "colgroup", width: "8.33%" },
          { type: "colgroup", width: "8.33%" },
          { type: "colgroup", width: "8.33%" },
          { type: "colgroup", width: "8.33%" },
          { type: "colgroup", width: "8.33%" },
          { type: "colgroup", width: "8.33%" },
          { type: "colgroup", width: "8.33%" }
        ],
        table: [
          [
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefType),
              value: i + 1,
              colSpan: 2,
              width: "16.66%"
            },
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefName),
              value: item.data.clientBenefName,
              colSpan: 4,
              width: "33.33%"
            },
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefSurname),
              value: item.data.clientBenefSurname,
              colSpan: 6,
              width: "50%"
            }
          ],
          [
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefId),
              value: item.data.clientBenefId,
              colSpan: 6
            },
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefBirthDate),
              value: item.data.clientBenefBirthDate,
              colSpan: 6
            }
          ],
          [
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefCountry),
              value: CISO?.[item.data.clientBenefRegCountry],
              colSpan: 6
            },
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefAddress),
              value: item.data.clientBenefAddress,
              colSpan: 6
            }
          ],
          [
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefIdDoc),
              value: DOCS?.[item.data.clientBenefIdDoc],
              colSpan: 4,
              width: "33.33%"
            },
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefDocNo),
              value: item.data.clientBenefDocNo,
              colSpan: 4,
              width: "33.33%"
            },
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefRegCountry),
              value: CISO?.[item.data.clientBenefRegCountry],
              colSpan: 4,
              width: "33.33%"
            }
          ],
          [
            {
              type: "radio",
              title: trb(i18.Labels.OtherCeoCitizien),
              options: [
                { label: trb(i18.Labels.No), value: "0", className: "col-12" },
                { label: trb(i18.PrintLabels.YesPleaseSpecify), value: "1", className: "col-12" }
              ],
              value: item.data.otherClientBenefRegCountry,
              footerText: trb(i18.PrintLabels.AttachPassportIDPermit),
              colSpan: 6
            },

            {
              type: "radio",
              title: trb(i18.Labels.OtherCeoCitizienSch),
              value: clientCeo?.[0]?.data?.otherCeoCitizienSch,
              options: [
                { label: trb(i18.Labels.Yes), value: "1", className: "col-12" },
                { label: trb(i18.Labels.No), value: "0", className: "col-12" }
              ],
              colSpan: 6
            }
          ],
          [
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefShare),
              value: item.data.clientBenefShare,
              colSpan: 12
            }
          ],
          [
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefTaxCountry),
              value: CISO?.[item.data.clientBenefTaxCountry],
              colSpan: 4
            },
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefTaxId),
              value: item.data.clientBenefTaxId,
              colSpan: 4
            },
            {
              type: "input",
              title: trb(i18.Labels.ClientBenefEmail),
              value: item.data.clientBenefEmail,
              colSpan: 4
            }
          ],
          [
            {
              type: "input",
              title: trb(i18.Labels.PhoneNumber),
              value: item.data.clientBenefPhoneNo,
              colSpan: 6
            },
            {
              type: "input",
              title: trb(i18.Labels.BeneficiaryFunds),
              value: SWC?.[item.data.beneficiaryFunds],
              colSpan: 6
            }
          ]
        ]
      };
    });
    return benef;
  };

  const getClientAddressTableElements = () => {
    const array = clientAddress.map((item, i) => {
      return [
        [
          {
            type: "input",
            title: trb(i18.Labels.AddressType),
            value: ADRT?.[item?.addressType],
            colSpan: 2
          },
          {
            type: "input",
            title: trb(i18.Labels.AddressCountry),
            value: CISO?.[item?.data.addressCountry],
            colSpan: 2
          },
          {
            type: "input",
            title: trb(i18.Labels.AddressCity),
            value: item?.data.addressCity,
            colSpan: 2
          }
        ],
        [
          {
            type: "input",
            title: trb(i18.Labels.AddressStreet),
            value: item?.data.addressStreet,
            colSpan: 3
          },
          {
            type: "input",
            title: trb(i18.Labels.AddressPostCode),
            value: item?.data.addressPostCode,
            colSpan: 3
          }
        ]

        /* {
          return [
             [
              {
                type: "input",
                title: trb(i18.Labels.PhoneNumber),
                value: clientAddress?.[0]?.data.clientPhoneNo,
                width: "50%"
              },
              {
                type: "input",
                title: trb(i18.PrintLabels.WWWAdress),
                value: clientProfile?.[0].data.clientWeb || "-",
                colSpan: 2
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.PrintLabels.ClientTaxPayerId),
                value: clientTaxPayerCountrys?.[0]?.data?.clientTaxPayerId,
                width: "50%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientTaxPayerCountry),
                value: CISO?.[clientTaxPayerCountrys?.[0]?.data.clientTaxPayerCountry],
                colSpan: 2
              }
            ]
          ];
        })
      },*/
      ];
    });
    const retArray = [];
    array.forEach(el => {
      retArray.push(...el);
    });
    retArray.push([
      {
        type: "input",
        title: trb(i18.Labels.ClientEmail),
        value: clientMail?.[0]?.data.clientEmail,
        colSpan: 3
      },
      {
        type: "input",
        title: trb(i18.Labels.ClientPhoneNo),
        value: clientPhone?.[0]?.data.clientPhoneNo,
        colSpan: 3
      }
    ]);
    retArray.push([
      {
        type: "input",
        title: trb(i18.PrintLabels.WWWAdress),
        value: clientProfile?.[0].data.clientWeb,
        colSpan: 6,
        width: "100%"
      }
    ]);
    retArray.push([
      {
        type: "input",
        title: trb(i18.PrintLabels.ClientTaxPayerId),
        value: clientTaxPayerCountrys?.[0]?.data?.clientTaxPayerId,
        colSpan: 3
      },
      {
        type: "input",
        title: trb(i18.Labels.ClientTaxPayerCountry),
        value: CISO?.[clientTaxPayerCountrys?.[0]?.data.clientTaxPayerCountry],
        colSpan: 3
      }
    ]);
    return retArray;
  };

  const getIncomeFromCoutries = () => {
    const countries = [
      [
        {
          type: "input",
          title: trb(i18.Labels.IncomFrom),
          width: "100%",
          colSpan: "9"
        }
      ]
    ];
    let lineArr = [];
    clientFundsRecCountrys.forEach((el, i) => {
      lineArr.push({
        type: "input",
        title: trb(i18.Labels.CustomerCountry),
        value: CISO?.[el?.data?.clientFundsRecCountry],
        colSpan: clientFundsRecCountrys.length < 9 - 3 * clientFundsRecCountrys.length ? "9" : "3"
      });
      if (i % 3 === 2 || i === clientFundsRecCountrys.length - 1) {
        countries.push(lineArr);
        lineArr = [];
      }
    });

    return countries;
  };

  const getMainCustoms = () => {
    const mainCustoms = [
      [
        {
          type: "input",
          title: trb(i18.Labels.MainCustom),
          width: "100%",
          colSpan: "9"
        }
      ]
    ];
    mainCustom.forEach((el, i) => {
      // eslint-disable-next-line no-unused-expressions
      el.data
        ? mainCustoms.push([
            {
              type: "input",
              title: trb(i18.PrintLabels.ClientNo),
              value: i + 1,
              colSpan: "1",
              width: "11.11%"
            },
            {
              type: "input",
              title: trb(i18.PrintLabels.ClientNameCountry),
              value: `${el?.data?.customerName}, ${CISO?.[el?.data?.customerCountry]}`,
              colSpan: "5",
              width: "55.55%"
            },
            {
              type: "input",
              title: trb(i18.Labels.CustomerActivity),
              value: CBB?.[el?.data?.customerActivity],
              colSpan: "3",
              width: "33.33%"
            }
          ])
        : null;
    });

    return mainCustoms;
  };

  const getClientBasicBusiness = () => {
    const rows = [];
    clientBasicBusiness.forEach((el, i) => {
      rows.push([
        {
          type: "input",
          title: trb(i18.PrintLabels.ActivityNo),
          value: i + 1,
          width: "50%"
        },
        {
          type: "input",
          title: trb(i18.Labels.ClientBasicBusiness),
          value: CBB[el.data.clientBasicBusiness],
          width: "50%"
        }
      ]);
    });
    return rows;
  };

  const getExpensesFromCoutries = () => {
    const countries = [
      [
        {
          type: "input",
          title: trb(i18.PrintLabels.FillAtLeastThreeCountriesWithHighestPlannedExpenses),
          width: "100%",
          colSpan: "9"
        }
      ]
    ];
    let lineArr = [];
    clientFundsSentCountry.forEach((el, i) => {
      lineArr.push({
        type: "input",
        title: trb(i18.Labels.CustomerCountry),
        value: CISO?.[el?.data?.clientFundsSentCountry],
        colSpan: "3",
        width: "33.33%"
      });
      if (i % 3 === 2 || i === clientFundsSentCountry.length - 1) {
        countries.push(lineArr);
        lineArr = [];
      }
    });

    return countries;
  };
  const getMainSuppliers = () => {
    const clientBusPartners = [
      [
        {
          type: "input",
          title: trb(i18.Labels.MainBusPartner),
          width: "100%",
          colSpan: "9"
        }
      ]
    ];
    clientBusPartner.forEach((el, i) => {
      clientBusPartners.push([
        {
          type: "input",
          title: trb(i18.PrintLabels.SupplierNo),
          value: i + 1,
          colSpan: "1",
          width: "11.11%"
        },
        {
          type: "input",
          title: trb(i18.PrintLabels.ClientNameCountry),
          value: `${el.data.clientBusPartnerName}, ${CISO?.[el?.data?.clientBusPartnerCountry]}`,
          colSpan: "5",
          width: "55.55%"
        },
        {
          type: "input",
          title: trb(i18.Labels.ClientBusPartnerAct),
          value: CBB?.[el?.data?.clientBusPartnerAct],
          colSpan: "3",
          width: "33.33%"
        }
      ]);
    });

    return clientBusPartners;
  };

  const printData = [
    {
      title: trb(i18.Labels.ClientProfile),
      data: [
        {
          type: "table",
          table: [
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientTitle),
                value: clientProfile?.[0].data.clientFullName,
                colSpan: 2,
                width: "100%"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.BrandName),
                value: clientProfile?.[0].data.brandName,
                colSpan: 2,
                width: "100%"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.PrintLabels.LegalForm),
                value:
                  clientProfile?.[0]?.data.companyTypeTextValue ||
                  LGL_FRM?.[clientProfile?.[0]?.data.clientLegalStatus]
              },
              {
                type: "input",
                title: trb(i18.Labels.CompanyCode),
                value: clientProfile?.[0].data.clientId
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientBirthDate),
                value: moment(clientProfile?.[0].data.clientBirthDate).format("YYYY-MM-DD")
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientRegCountry),
                value: CISO?.[clientProfile?.[0].data.clientRegCountry]
              }
            ]
          ]
        }
      ]
    },
    {
      title: trb(i18.Labels.ClientAddress),
      data: [
        {
          type: "table",
          groupOptions: [
            { type: "colgroup", width: "16.66%" },
            { type: "colgroup", width: "16.66%" },
            { type: "colgroup", width: "16.66%" },
            { type: "colgroup", width: "16.66%" },
            { type: "colgroup", width: "16.66%" },
            { type: "colgroup", width: "16.66%" }
          ],
          table: getClientAddressTableElements()
        },
        {
          type: "text",
          data: {
            value: trb(i18.PrintLabels.ClientTaxPayerIdInfoMessage)
          }
        }
      ]
    },
    {
      title: trb(i18.PrintLabels.BankServicesAndProductsYouPlanToUse),
      data: [
        {
          type: "table",
          table: [
            [
              {
                type: "checkboxesH",
                options: [
                  {
                    label: trb(i18.Labels.ClientPlanServicesCard),
                    value: "clientPlanServicesCard"
                  },
                  {
                    label: trb(i18.Labels.ClientPlanServicesTransf),
                    value: "clientPlanServicesTransf"
                  },
                  {
                    label: trb(i18.Labels.ClientPlanServicesCredSb),
                    value: "clientPlanServicesCredSb"
                  },
                  { label: trb(i18.Labels.ClientPlanServicesDep), value: "clientPlanServicesDep" },
                  { label: trb(i18.Labels.ClientPlanServicesEb), value: "clientPlanServicesEb" }
                ],
                values: clientPlanServices?.[0]?.data || []
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.PrintLabels.TypeOfAccount),
                value: clientPlanServices?.[0]?.data?.bankAccType,
                options: [
                  { label: ACCT.ACCT10, value: "ACCT10" },
                  { label: ACCT.ACCT40, value: "ACCT40" },
                  { label: ACCT.ACCT41, value: "ACCT41" }
                ],
                width: "100%"
              }
            ]
          ]
        }
      ]
    },
    {
      title: trb(i18.Labels.CompanyFunds),
      data: [
        {
          type: "table",
          table: [
            [
              {
                type: "checkboxesH",
                options: [
                  {
                    label: trb(i18.Labels.CompanyFundsShareholderCap),
                    value: "shareholderCap",
                    className: "col-3"
                  },
                  {
                    label: trb(i18.Labels.CompanyFundsActivityProfit),
                    value: "activityProfit",
                    className: "col-3"
                  },
                  {
                    label: trb(i18.Labels.CompanyFundsSaleProperty),
                    value: "saleProperty",
                    className: "col-3"
                  },
                  {
                    label: trb(i18.Labels.CompanyFundsIncomInvest),
                    value: "incomInvest",
                    className: "col-3"
                  },
                  {
                    label: trb(i18.Labels.CompanyFundsSubsidies),
                    value: "subsidies",
                    className: "col-3"
                  },
                  {
                    label: trb(i18.Labels.CompanyFundsBorroving),
                    value: "borroving",
                    className: "col-3"
                  },
                  { label: trb(i18.Labels.CompanyFundsOther), value: "other", className: "col-3" }
                ],
                values: companyFunds?.[0]?.data || []
              }
            ],
            companyFunds?.[0]?.data.other === "1"
              ? [
                  {
                    type: "input",
                    title: trb(i18.PrintLabels.AccountOpeningReason),
                    value: companyFunds?.[0]?.data?.otherInput || "-"
                  }
                ]
              : null
          ]
        }
      ]
    },
    {
      title: trb(i18.PrintLabels.CeoInfo),
      data: [
        {
          type: "table",
          table: [
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientRepPosition),
                value: clientProfile?.[0].data.clientRepPosition,
                colSpan: "3"
              }
            ],
            [
              {
                type: "checkboxes",
                options: [{ label: CMP.CMP1, value: "whoOpenAccount" }],
                values: {
                  whoOpenAccount: clientProfile?.[0]?.data?.whoOpenAccount === "CMP1"
                },
                width: "33.3%"
              },
              {
                type: "checkboxes",
                options: [{ label: CMP.CMP2, value: "whoOpenAccount" }],
                values: {
                  whoOpenAccount: clientProfile?.[0]?.data?.whoOpenAccount === "CMP2"
                },
                width: "33.4%"
              },
              {
                type: "checkboxes",
                options: [{ label: CMP.CMP4, value: "whoOpenAccount" }],
                values: {
                  whoOpenAccount: clientProfile?.[0]?.data?.whoOpenAccount === "CMP4"
                },
                width: "33.3%"
              }
            ],
            [
              {
                type: "checkboxes",
                options: [{ label: CMP.CMP3, value: "whoOpenAccount" }],
                values: {
                  whoOpenAccount: clientProfile?.[0]?.data?.whoOpenAccount === "CMP3"
                },
                colSpan: "3"
              }
            ]
          ]
        },
        {
          title: trb(i18.Labels.ClientCeo),
          type: "table",
          groupOptions: [
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" }
          ],
          table: [
            /* [
              {
                type: "checkboxes",
                options: [
                  { label: trb(i18.WhoOpenAccount.CEO), value: "CEO" },
                  { label: trb(i18.WhoOpenAccount.REP), value: "REP" }
                ],
                values: {
                  REP: clientProfile?.[0].data.whoOpenAccount === "CMP2",
                  CEO: clientProfile?.[0].data.whoOpenAccount === "CMP1"
                },
                colSpan: "6",
                width: "50%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientRepPosition),
                value: clientProfile?.[0].data.clientRepPosition,
                colSpan: "6"
              }
            ], */
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientCeoName),
                value: clientCeo?.[0].data.clientCeoName,
                colSpan: "3",
                width: "25%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientSurname),
                value: clientCeo?.[0].data.clientCeoSurname,
                colSpan: "3",
                width: "25%"
              },
              {
                type: "input",
                title: trb(i18.PrintLabels.ClientCodeOrBirthday),
                value:
                  clientCeo?.[0].data.clientCeoId ||
                  moment(clientCeo?.[0].data.clientCeoBirthDate).format("YYYY-MM-DD"),
                colSpan: "3",
                width: "25%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientRepRegCountry),
                value: CISO?.[clientCeo?.[0]?.data.clientCeoCitizien],
                colSpan: "3",
                width: "25%"
              }
            ],
            [
              {
                type: "checkboxes",
                title: trb(i18.Labels.OtherCeoCitizien),
                value: clientCeo?.[0]?.data.clientCeoDocNo,
                options: [
                  { label: trb(i18.Labels.No), value: "no" },
                  { label: trb(i18.PrintLabels.YesPleaseSpecify), value: "yes" }
                ],
                values: {
                  yes: clientCeo?.[0]?.data?.otherCeoCitizien === "1",
                  no: clientCeo?.[0]?.data?.otherCeoCitizien !== "1"
                },
                footerText: trb(i18.PrintLabels.AttachPassportIDPermit),
                colSpan: "6"
              },
              {
                title: trb(i18.Labels.OtherCeoCitizienSch),
                type: "checkboxes",
                options: [
                  { label: trb(i18.Labels.Yes), value: "yes" },
                  { label: trb(i18.Labels.No), value: "no" }
                ],
                values: {
                  yes: clientCeo?.[0]?.data?.otherCeoCitizienSch === "1",
                  no: clientCeo?.[0]?.data?.otherCeoCitizienSch !== "1"
                },
                colSpan: "6"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientCeoCountry),
                value: CISO?.[clientCeo?.[0]?.data.clientCeoCountry],
                colSpan: "4",
                width: "33.3%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientCeoCity),
                value: clientCeo?.[0]?.data.clientCeoCity,
                colSpan: "4",
                width: "33.3%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientCeoStreet),
                value: clientCeo?.[0]?.data.clientCeoStreet,
                colSpan: "4",
                width: "33.3%"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.PhoneNumber),
                value: clientCeo?.[0]?.data.clientCeoPhone,
                colSpan: "6"
              },
              {
                type: "input",
                title: trb(i18.PrintLabels.DocumentType),
                value: DOCS?.[clientCeo?.[0]?.data.clientCeoIdDocType],
                colSpan: "6"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientCeoDocCountry),
                value: CISO?.[clientCeo?.[0]?.data.clientCeoDocCountry],
                colSpan: "4",
                width: "33.3%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientCeoDocIssueDate),
                value: clientCeo?.[0]?.data.clientCeoDocIssueDate,
                colSpan: "4",
                width: "33.3%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientCeoDocIssuePlace),
                value: clientCeo?.[0]?.data.clientCeoDocIssuePlace,
                colSpan: "4",
                width: "33.3%"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientCeoDocNo),
                value: clientCeo?.[0]?.data.clientCeoDocNo,
                colSpan: "6"
              },
              {
                type: "input",
                title: trb(i18.PrintLabels.ValidTill),
                value: clientCeo?.[0]?.data.clientCeoDocValidDate,
                colSpan: "6"
              }
            ]
          ]
        },
        {
          title: CMP.CMP2,
          type: "table",
          groupOptions: [
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" },
            { type: "colgroup", width: "8.3%" }
          ],
          table: [
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientRepName),
                value: clientRep?.[0]?.data?.clientRepName,
                colSpan: "3",
                width: "25%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientRepSurname),
                value: clientRep?.[0]?.data?.clientRepSurname,
                colSpan: "3",
                width: "25%"
              },
              {
                type: "input",
                title: trb(i18.PrintLabels.ClientCodeOrBirthday),
                value:
                  clientRep?.[0]?.data?.clientRepId ||
                  moment(clientRep?.[0]?.data?.clientRepBirthDate).format("YYYY-MM-DD"),
                colSpan: "3",
                width: "25%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientRepRegCountry),
                value: CISO?.[clientRep?.[0]?.data?.clientRepRegCountry],
                colSpan: "3",
                width: "25%"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientRepCountry),
                value: CISO?.[clientRep?.[0]?.data?.clientRepCountry],
                colSpan: "4",
                width: "33.3%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientRepCity),
                value: clientRep?.[0]?.data?.clientRepCity,
                colSpan: "4",
                width: "33.3%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientRepStreet),
                value: clientRep?.[0]?.data?.clientRepStreet,
                colSpan: "4",
                width: "33.3%"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientRepPhoneNo),
                value: clientRep?.[0]?.data?.clientRepPhoneNo,
                colSpan: "6"
              },
              {
                type: "input",
                title: trb(i18.PrintLabels.DocumentType),
                value: DOCS?.[clientRep?.[0]?.data?.clientRepIdDocType],
                colSpan: "6"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientRepDocCountry),
                value: CISO?.[clientRep?.[0]?.data?.clientRepDocCountry],
                colSpan: "4",
                width: "33.3%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientRepDocIssueDate),
                value: clientRep?.[0]?.data?.clientRepDocIssueDate,
                colSpan: "4",
                width: "33.3%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientRepDocIssuePlace),
                value: clientRep?.[0]?.data?.clientRepDocIssuePlace,
                colSpan: "4",
                width: "33.3%"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientRepDocNo),
                value: clientRep?.[0]?.data?.clientRepDocNo,
                colSpan: "4",
                width: "33.3%"
              },
              {
                type: "input",
                title: trb(i18.PrintLabels.ValidTill),
                value: clientRep?.[0]?.data?.clientRepDocValidDate,
                colSpan: "4",
                width: "33.3%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientRepMandatValidDate),
                value: clientRep?.[0]?.data?.clientRepMandatValidDate,
                colSpan: "4",
                width: "33.3%"
              }
            ]
          ]
        }
      ]
    },
    {
      title: trb(i18.PrintLabels.PoliticallyVulnerablePersons),
      data: [
        {
          type: "table",
          table: [
            [
              {
                type: "text",
                value: trb(i18.Messages.PoliticallyExposedPersonNote),
                width: "100%",
                colSpan: "4"
              }
            ],
            [
              {
                type: "checkboxes",
                options: [{ label: trb(i18.Labels.No), value: "no" }],
                values: {
                  no: clientProfile?.[0].data.clientPoliticsMember !== "1"
                },
                width: "100%",
                colSpan: "4"
              }
            ],
            [
              {
                // title: trb(i18.PrintLabels.SpecifyPersonPosition),
                type: "checkboxesH",
                options: [
                  {
                    label: trb(i18.PrintLabels.YesClientPoliticsMember),
                    value: "yes",
                    className: "col-12 mb-4"
                  },
                  {
                    label: trb(i18.Labels.ClientPoliticsMinist),
                    value: "clientPoliticsMinist",
                    className: "col-6 pr-2"
                  },
                  {
                    label: trb(i18.Labels.ClientPoliticsAmb),
                    value: "clientPoliticsAmb",
                    className: "col-6 pr-2"
                  },
                  {
                    label: trb(i18.PrintLabels.ParlamentMember),
                    value: "clientPoliticsParl",
                    className: "col-6 pr-2"
                  },
                  {
                    label: trb(i18.Labels.ClientPoliticArmForces),
                    value: "clientPoliticArmForces",
                    className: "col-6 pr-2"
                  },
                  {
                    label: trb(i18.Labels.ClientPoliticsJutge),
                    value: "clientPoliticsJutge",
                    className: "col-6 pr-2"
                  },
                  {
                    label: trb(i18.Labels.ClientPoliticsJoint),
                    value: "clientPoliticsJoint",
                    className: "col-6 pr-2"
                  },
                  {
                    label: trb(i18.Labels.ClientPoliticsMay),
                    value: "clientPoliticsMay",
                    className: "col-6 pr-2"
                  },
                  {
                    label: trb(i18.Labels.ClientPoliticsInternOrg),
                    value: "clientPoliticsInternOrg",
                    className: "col-6 pr-2"
                  },
                  {
                    label: trb(i18.Labels.ClientPoliticsAudit),
                    value: "clientPoliticsAudit",
                    className: "col-6 pr-2"
                  },
                  {
                    label: trb(i18.Labels.ClientPoliticsPolPart),
                    value: "clientPoliticsPolPart",
                    className: "col-6 pr-2"
                  },
                  {
                    label: trb(i18.Labels.ClientPoliticsMJoint),
                    value: "clientPoliticsMJoint",
                    className: "col-6 pr-2"
                  },
                  {
                    label: trb(i18.Labels.ClientPoliticOther),
                    value: "clientPoliticOther",
                    className: "col-6 pr-2"
                  }
                ],
                values:
                  {
                    ...clientPoliticsPosition?.[0]?.data,
                    yes: clientProfile?.[0].data.clientPoliticsMember === "1"
                  } || null,
                colSpan: "4"
              }
            ],
            /* [
              {
                title: trb(i18.Labels.ClientPoliticsList),
                type: "checkboxes",
                options: [
                  { label: trb(i18.PrintLabels.Myself), value: "PEPLIST1" },
                  { label: trb(i18.PrintLabels.CloseFamilyMember), value: "PEPLIST2" }
                ],
                values: {
                  PEPLIST1: clientPolitics?.[0]?.clientPoliticsList === "PEPLIST1" ? "1" : "0",
                  PEPLIST2: clientPolitics?.[0]?.clientPoliticsList === "PEPLIST2" ? "1" : 0
                },
                colSpan: "4"
              }
            ], */
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientPoliticsName),
                value: clientPolitics?.[0]?.data.clientPoliticsName,
                width: "25%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientPoliticsCountry),
                value: CISO?.[clientPolitics?.[0]?.data.clientPoliticsCountry],
                width: "25%"
              },
              {
                type: "input",
                title: trb(i18.Labels.PepInstitution),
                value: clientPolitics?.[0]?.data.pepInstitution,
                width: "25%"
              },
              {
                type: "input",
                title: trb(i18.Labels.ClientPep_Id),
                value: clientPolitics?.[0]?.data.clientPep_Id,
                width: "25%"
              }
            ]
          ]
        }
      ]
    },
    {
      title: trb(i18.PrintLabels.Operations),
      data: [
        {
          type: "table",
          table: [
            [
              {
                type: "radio",
                title: trb(i18.Labels.IncPaym),
                value: clientPlanTurn?.[0]?.data?.incPaym,
                options: classifikatorsMap(INCPM, true, customSortByValueString),
                width: "100%",
                colSpan: "2"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.Labels.IncRem),
                value: clientPlanTurn?.[0]?.data?.incRem,
                options: classifikatorsMap(INCRM, true, customSortByValueString),
                width: "100%",
                colSpan: "2"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.Labels.ClientPaymCash),
                value: clientPaymentForServises?.[0]?.data?.clientPaymCash,
                options: classifikatorsMap(CPFSCH, true, customSortByValueString, "col-12"),
                width: "50%"
              },
              {
                type: "radio",
                title: trb(i18.Labels.ClientPaymCryp),
                value: clientPaymentForServises?.[0]?.data?.clientPaymCryp,
                options: classifikatorsMap(CPFSC, true, customSortByValueString, "col-12"),
                width: "50%"
              }
            ]
          ]
        }
      ]
    },

    {
      title: trb(i18.PrintLabels.Income),
      data: [
        {
          type: "table",
          groupOptions: [
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" }
          ],
          table: [...getIncomeFromCoutries(), ...getMainCustoms()]
        }
      ]
    },

    {
      title: trb(i18.PrintLabels.BeneficiariesLegalEntity),
      data: [
        {
          type: "table",
          table: [
            [
              {
                title: trb(i18.Messages.TradeSecur2),
                type: "checkboxesH",
                options: [
                  { label: trb(i18.Labels.Yes), value: "tradeSecurYes", className: "col-5" },
                  { label: trb(i18.Labels.No), value: "tradeSecurNo", className: "col-5" }
                ],
                values: {
                  tradeSecurYes: clientBeneficiaries?.[0]?.data?.tradeSecur === "1",
                  tradeSecurNo: clientBeneficiaries?.[0]?.data?.tradeSecur !== "1"
                },
                width: "75%"
              },
              {
                type: "input",
                title: trb(i18.Labels.IsinCode),
                value: clientBeneficiaries?.[0]?.data?.isinCode,
                width: "25%"
              }
            ]
          ]
        },
        {
          type: "text",
          data: {
            value: trb(i18.Messages.ClientBenefecariesNoteAfter2)
          }
        },
        ...getClientBeneficiaries(),
        {
          title: trb(i18.Labels.ClientBasicBusiness),
          type: "table",
          table: [
            ...getClientBasicBusiness(),
            [
              {
                type: "input",
                title: trb(i18.Labels.InsSect),
                value: INSTTTNL_SCTR?.[clientProfile?.[0]?.data.insSect],
                width: "100%",
                colSpan: "2"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientServicesDescription),
                value: clientProfile?.[0]?.data.clientServicesDescription,
                width: "100%",
                colSpan: "2"
              }
            ],
            [
              {
                type: "checkboxes",
                title: trb(i18.Labels.RequireBusinessLicense),
                options: [{ label: trb(i18.Labels.No), value: "no", className: "col-5" }],
                values: {
                  no: clientProfile?.[0]?.data.requireBusinessLicense !== "1"
                },
                width: "100%",
                colSpan: "2"
              }
            ],
            [
              {
                type: "checkboxes",
                options: [{ label: trb(i18.Labels.Yes), value: "yes", className: "col-5" }],
                values: {
                  yes: clientProfile?.[0]?.data.requireBusinessLicense === "1"
                },
                width: "50%",
                colSpan: "1",
                rowSpan: "5"
              },
              {
                type: "input",
                title: trb(i18.Labels.BusinessLicenseNumber),
                value: clientProfile?.[0]?.data.businessLicenseNumber,
                width: "50%",
                colSpan: "1",
                className: "noLeftBorder"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.Labels.AmlRulesLeg),
                value:
                  clientProfile?.[0]?.data.requireBusinessLicense === "1"
                    ? clientProfile?.[0]?.data.amlRulesLeg
                    : "-1",
                options: yesNo,
                width: "100%",
                colSpan: "2"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.Labels.AmlProcedure),
                value: clientProfile?.[0]?.data.amlProcedure,
                options: yesNo,
                width: "100%",
                colSpan: "2"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.AmlCheckInSancLis),
                value: clientProfile?.[0]?.data.amlCheckInSancLis,
                width: "100%",
                colSpan: "2"
              }
            ],
            [
              {
                type: "mapInfo",
                title: trb(i18.Labels.AmlOfficer),
                value: clientProfile?.[0]?.data.businessLicenseNumber,
                width: "100%",
                data: [
                  {
                    title: trb(i18.Labels.AmlOfficerNameSur),
                    value: clientProfile?.[0]?.data.amlOfficerNameSur,
                    className: "col-12"
                  },
                  {
                    title: trb(i18.Labels.AmlOfficerEmail),
                    value: clientProfile?.[0]?.data.amlOfficerEmail,
                    className: "col-12"
                  },
                  {
                    title: trb(i18.Labels.AmlOfficerPhone),
                    value: clientPhone?.[0]?.data.amlOfficerPhone,
                    className: "col-12"
                  }
                ],
                colSpan: "2"
              }
            ]
          ]
        }
      ]
    },
    {
      title: trb(i18.Labels.ClientSize),
      data: [
        {
          type: "table",
          table: [
            [
              {
                type: "input",
                title: trb(i18.Labels.YearlyIncome),
                value: clientBasicBusiness?.[0]?.data?.yearlyIncome,
                width: "50%"
              },
              {
                type: "input",
                title: trb(i18.Labels.BalAsst),
                value: clientProfile?.[0]?.data.balAsst,
                width: "50%"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.Labels.ClientEmployeeQty),
                value: clientProfile?.[0]?.data.clientEmployeeQty,
                width: "50%"
              },
              {
                type: "radio",
                title: trb(i18.Labels.ClientSize),
                value: clientProfile?.[0]?.data.clientSize,
                options: classifikatorsMap(CSIZE, true, customSortByValueString),
                radioClassName: "col-6",
                width: "50%"
              }
            ]
          ]
        },
        {
          title: trb(i18.PrintLabels.PlannedTurnoverEURPerMonth),
          type: "table",
          table: [
            [
              {
                type: "radio",
                title: trb(i18.Labels.OutPaym),
                value: PaymOut?.[0]?.data?.paymOut,
                options: classifikatorsMap(OUTPM, true, customSortByValueString),
                width: "100%"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.Labels.OutRem),
                value: PaymOut?.[0]?.data?.remOut,
                options: classifikatorsMap(OUTRM, true, customSortByValueString),
                width: "100%"
              }
            ]
          ]
        }
      ]
    },
    {
      title: trb(i18.PrintLabels.SpecifyMainSuppliersTheirCountriesAndAreasOfActivity),
      data: [
        {
          type: "table",
          table: [
            [
              {
                type: "radio",
                title: trb(i18.Labels.CurrExc),
                value: planServTurn?.[0]?.data?.currExchange,
                options: classifikatorsMap(CUREX, true, customSortByValueString),

                width: "100%"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.Labels.Loan),
                value: planServTurn?.[0]?.data?.loanSum,
                options: classifikatorsMap(LNAM, true, customSortByValueString),
                width: "100%"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.PrintLabels.Deposits),
                value: planServTurn?.[0]?.data?.moInAcc,
                options: classifikatorsMap(MCA, true, customSortByValueString),
                width: "100%"
              }
            ]
          ]
        },
        {
          title: trb(i18.PrintLabels.Expenses),
          type: "table",
          groupOptions: [
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" },
            { type: "colgroup", width: "11.11%" }
          ],
          table: [...getExpensesFromCoutries(), ...getMainSuppliers()]
        },
        {
          type: "composedDivs",
          data: [
            {
              title: trb(i18.Labels.Confirmation),
              type: "signatureDiv",
              data: {
                mainText: trb(i18.Messages.Confirmation),
                signatureText: trb(i18.PrintLabels.ClientSignatureAndDate)
              }
            },
            {
              title: trb(i18.Labels.PersonalDataProccessing),
              type: "signatureDiv",
              data: {
                mainText: trb(i18.Messages.PersonalDataProccessing),
                signatureText: trb(i18.PrintLabels.ClientSignature)
              }
            },
            {
              type: "table",
              table: [
                [
                  {
                    type: "radio",
                    title: trb(i18.PrintLabels.AgreeReceivePromotionalNoticesFromBank),
                    value: clientProfile?.[0]?.data?.directMarketing,
                    options: yesNo,
                    width: "40%"
                  },
                  {
                    type: "radio",
                    title: trb(i18.Labels.ClientChannel),
                    value: clientProfile?.[0]?.data?.clientChannel,
                    options: classifikatorsMap(CCHAN, true, customSortByValueString),
                    radioClassName: "col-6",
                    width: "60%"
                  }
                ]
              ]
            },
            {
              type: "table",
              table: [
                [
                  {
                    type: "input",
                    title: trb(i18.PrintLabels.SignatureDirectorOrAuthorizedPersonDate),
                    width: "50%",
                    className: "height8rem"
                  },
                  {
                    type: "input",
                    title: trb(i18.PrintLabels.NameLastNameSignatureThatAcceptedQuestionnaire),
                    width: "50%"
                  }
                ]
              ]
            }
          ]
        }
      ]
    }
    /* {
      title: trb(i18.Labels.PlanServices),
      data: [
        {
          type: "table",
          table: [
            [
              {
                type: "radio",
                title: trb(i18.Labels.CurrExc),
                value: planServTurn?.[0]?.data?.currExchange,
                options: classifikatorsMap(CUREX, true, customSortByValueString),

                width: "100%"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.Labels.Loan),
                value: planServTurn?.[0]?.data?.loanSum,
                options: classifikatorsMap(LNAM, true, customSortByValueString),
                width: "100%"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.PrintLabels.Deposits),
                value: planServTurn?.[0]?.data?.moInAcc,
                options: classifikatorsMap(MCA, true, customSortByValueString),
                width: "100%"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.Labels.IncPaym),
                value: clientPlanTurn?.[0]?.data?.incPaym,
                options: classifikatorsMap(INCPM, true, customSortByValueString),
                width: "100%"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.Labels.IncRem),
                value: clientPlanTurn?.[0]?.data?.incRem,
                options: classifikatorsMap(INCRM, true, customSortByValueString),
                width: "100%"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.Labels.OutPaym),
                value: PaymOut?.[0]?.data?.paymOut,
                options: classifikatorsMap(OUTPM, true, customSortByValueString),
                width: "100%"
              }
            ],
            [
              {
                type: "radio",
                title: trb(i18.Labels.OutRem),
                value: PaymOut?.[0]?.data?.remOut,
                options: classifikatorsMap(OUTRM, true, customSortByValueString),
                width: "100%"
              }
            ]
          ]
        }
      ]
    },
    {
      title: trb(i18.Labels.ClientBusPartnerAct),
      data: [
        {
          type: "table",
          table: [
            [
              {
                type: "input",
                title: trb(i18.Labels.InsSect),
                value: INSTTTNL_SCTR?.[clientProfile?.[0]?.data.insSect],
                width: "100%"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.PrintLabels.MainActivityCode),
                value: CBB?.[clientBasicBusiness?.[0]?.data?.clientBasicBusiness],
                width: "100%"
              }
            ]
          ]
        }
      ]
    },
    {
      title: trb(i18.PrintLabels.MainCustom),
      data: [
        mainCustom?.length && mainCustom?.[0]?.retail !== "1"
          ? {
              type: "table",
              table: mainCustom.map((item, i) => {
                return [
                  {
                    type: "input",
                    title: trb(i18.PrintLabels.ClientNo),
                    value: i + 1,
                    width: "10%"
                  },
                  {
                    type: "input",
                    title: trb(i18.Labels.CustomerName),
                    value: item?.data?.customerName,
                    width: "25%"
                  },
                  {
                    type: "input",
                    title: trb(i18.Labels.CustomerCountry),
                    value: CISO?.[item?.data?.customerCountry],
                    width: "15%"
                  },
                  {
                    type: "input",
                    title: trb(i18.Labels.CustomerActivity),
                    value: CBB?.[item?.data?.customerActivity],
                    width: "50%"
                  }
                ];
              })
            }
          : {
              type: "table",
              table: [
                [
                  {
                    type: "checkboxes",
                    options: [
                      {
                        label: trb(i18.Labels.Retail),
                        value: mainCustom?.[0]?.retail === "1" ? "yes" : "no"
                      },
                      {
                        label: trb(i18.Labels.CustomerEmpty),
                        value: mainCustom?.length ? "no" : "yes"
                      }
                    ],
                    values: {
                      yes: "1",
                      no: "0"
                    }
                  }
                ]
              ]
            }
      ]
    },

    {
      title: trb(i18.PrintLabels.MainBusPartner),
      data: [
        {
          type: "table",
          table: clientBusPartner?.length
            ? clientBusPartner.map((item, i) => {
                return [
                  {
                    type: "input",
                    title: trb(i18.PrintLabels.ClientNo),
                    value: i + 1,
                    width: "10%"
                  },
                  {
                    type: "input",
                    title: trb(i18.Labels.ClientBusPartnerName),
                    value: item?.data?.clientBusPartnerName,
                    width: "25%"
                  },
                  {
                    type: "input",
                    title: trb(i18.Labels.ClientBusPartnerCountry),
                    value: CISO?.[item?.data?.clientBusPartnerCountry],
                    width: "15%"
                  },
                  {
                    type: "input",
                    title: trb(i18.Labels.ClientBusPartnerAct),
                    value: CBB?.[item?.data?.clientBusPartnerAct],
                    width: "50%"
                  }
                ];
              })
            : [
                [
                  {
                    type: "checkboxes",
                    options: [
                      {
                        label: trb(i18.Labels.ClientBusPartnerEmpty),
                        value: "yes"
                      }
                    ],
                    values: {
                      yes: "1",
                      no: "0"
                    }
                  }
                ]
              ]
        }
      ]
    },
    {
      title: trb(i18.Labels.Confirmation),
      data: [
        {
          type: "text",
          data: {
            value: trb(i18.Messages.Confirmation),
            className: "pt-3"
          }
        },
        {
          type: "signatureLine",
          data: { label: trb(i18.PrintLabels.ClientSignatureAndDate), className: "pt-4, pb-4" }
        }
      ]
    },
    {
      title: trb(i18.Labels.PersonalDataProccessing),
      data: [
        {
          type: "text",
          data: {
            value: trb(i18.Messages.PersonalDataProccessing),
            className: "pt-3"
          }
        },
        {
          type: "signatureLine",
          data: { label: trb(i18.PrintLabels.ClientSignatureAndDate), className: "pt-4, pb-4" }
        },
        {
          type: "table",
          table: [
            [
              {
                type: "input",
                title: trb(i18.Labels.DirectMarketing),
                width: "50%"
              },
              {
                type: "radio",
                title: " ",
                value: clientProfile?.[0]?.data?.directMarketing,
                options: yesNo,
                width: "50%"
              }
            ],
            [
              {
                type: "input",
                title: trb(i18.PrintLabels.DateAndSignature),
                value: "",
                width: "50%"
              },
              {
                type: "input",
                title: trb(i18.PrintLabels.EmployeeInfoWhoAcceptedQuestionnaire),
                value: clientProfile?.[0]?.data?.clientManager,
                width: "50%"
              }
            ]
          ]
        }
      ]
    }*/
  ];
  return (
    <>
      {/* <button onClick={handlePrint}>PRINT</button> */}
      <div className="d-noneaw">
        <div ref={componenNegativeInformation}>
          <div className="m-0 pageRoot">
            <header className="KYCHeader">
              <Header />
            </header>
            <table className="kycPaging">
              <thead>
                <tr>
                  <td>&nbsp;</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <Title />
                    {printData.map((itm, j) => {
                      return <Group title={itm.title} data={itm.data} number={j + 1} key={j} />;
                    })}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>&nbsp;</td>
                </tr>
              </tfoot>
            </table>
            {/*<footer>
             <div className="page-number" id="page-number">
              page number???
            </div> 
          </footer> */}
          </div>
        </div>
      </div>
    </>
  );
};
